export const liveRoundMenuCloseHeight = 120;
export const gameRoundTime = 60;
export const color1 = '#00FF01';
export const color2 = '#FF00CA';
export const buttonHeight = 50;
export const deviceMinHeight = 800;
export const liveMenuDescriptionHeight = window.innerHeight > deviceMinHeight ? 150 : 110;
export const desktopSize=700;


const style00 = [
    {
        property:'--background-color',
        value:'#141C29'
    },
    {
        property:'--primary-color',
        value:'#00FF00'
    },
    {
        property:'--secondary-color',
        value:'#FF00CA'
    },
    {
        property:'--primar-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--secondary-font-color',
        value:'#969696'
    },
    {
        property:'--buttons-font-color',
        value:'#050503'
    },
    {
        property:'--pool-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--pool-size-background',
        value:'#141C29'
    },
    {
        property:'--card-header-font-color',
        value:'#050503'
    },
    {
        property:'--card-font-color',
        value:'#050503'
    },
    {
        property:'--card-buttons-font-color',
        value:'#050503'
    },
    {
        property:'--live-round-background',
        value:'#0F1724'
    },
    {
        property:'--live-price-font-color',
        value:'#050503'
    },
    {
        property:'--live-price-header-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--live-price-locked-font-color',
        value:'#7c7b73'
    },
    {
        property:'--bet-button-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-background',
        value:'#0F1724'
    },
    {
        property:'--bet-button-border-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-button-background-color',
        value:'#0F1724'
    },
    {
        property:'--bet-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-background',
        value:'#29303F'
    },
    {
        property:'--bet-modal-button-background-selected',
        value:'#F1F1F1'
    },   
    {
        property:'--bet-modal-button-font',
        value:'#F1F1F1'
    },   
    {
        property:'--bet-modal-button-font-selected',
        value:'#29303F'
    },       
    {
        property:'--win-color',
        value:'#00FF00'
    },
    {
        property:'--lose-color',
        value:'#FF00CA'
    },
    {
        property:'--circle-counter-background-color',
        value:'#141C29'
    },
    {
        property:'--circle-counter-color',
        value:'#F1F1F1'
    },
    {
        property:'--desktop-header-background-color',
        value:'#141C29'
    }      
]

const style01 = [
    {
        property:'--background-color',
        value:'#1E1E1E'
    },
    {
        property:'--primary-color',
        value:'#F0E323'
    },
    {
        property:'--secondary-color',
        value:'#AE6AFF'
    },
    {
        property:'--primar-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--pool-size-background',
        value:'#0f1724'
    },
    {
        property:'--secondary-font-color',
        value:'#969696'
    },
    {
        property:'--buttons-font-color',
        value:'#050503'
    },
    {
        property:'--pool-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--card-header-font-color',
        value:'#050503'
    },
    {
        property:'--card-font-color',
        value:'#050503'
    },
    {
        property:'--card-buttons-font-color',
        value:'#050503'
    },
    {
        property:'--live-round-background',
        value:'#2B2B2B'
    },
    {
        property:'--live-price-font-color',
        value:'#050503'
    },
    {
        property:'--live-price-header-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--live-price-locked-font-color',
        value:'#7c7b73'
    },
    {
        property:'--bet-button-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-background',
        value:'#1E1E1E'
    },
    {
        property:'--bet-button-border-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-button-background-color',
        value:'#1E1E1E'
    },
    {
        property:'--bet-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-background',
        value:'#2B2B2B'
    },
    {
        property:'--bet-modal-button-background-selected',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-font',
        value:'#F1F1F1'
    },   
    {
        property:'--bet-modal-button-font-selected',
        value:'#29303F'
    },  
    {
        property:'--win-color',
        value:'#F0E323'
    },
    {
        property:'--lose-color',
        value:'#AE6AFF'
    },
    {
        property:'--circle-counter-background-color',
        value:'#141C29'
    },
    {
        property:'--circle-counter-color',
        value:'#F1F1F1'
    },
    {
        property:'--desktop-header-background-color',
        value:'#2B2B2B'
    }                         
]

const style02 = [
    {
        property:'--background-color',
        value:'#FFFFFF'
    },
    {
        property:'--primary-color',
        value:'#F477FF'
    },
    {
        property:'--secondary-color',
        value:'#02FFFF'
    },
    {
        property:'--primar-font-color',
        value:'#050503'
    },
    {
        property:'--pool-size-background',
        value:'#0f1724'
    },
    {
        property:'--secondary-font-color',
        value:'#969696'
    },
    {
        property:'--buttons-font-color',
        value:'#050503'
    },
    {
        property:'--pool-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--card-header-font-color',
        value:'#050503'
    },
    {
        property:'--card-font-color',
        value:'#050503'
    },
    {
        property:'--card-buttons-font-color',
        value:'#050503'
    },
    {
        property:'--live-round-background',
        value:'#F1F1F1'
    },
    {
        property:'--live-price-font-color',
        value:'#050503'
    },
    {
        property:'--live-price-header-font-color',
        value:'#050503'
    },
    {
        property:'--live-price-locked-font-color',
        value:'#7c7b73'
    },
    {
        property:'--bet-button-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-background',
        value:'#FFFFFF'
    },
    {
        property:'--bet-button-border-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-button-background-color',
        value:'#0F1724'
    },
    {
        property:'--bet-modal-font-color',
        value:'#050503'
    },
    {
        property:'--bet-modal-button-background',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-background-selected',
        value:'#050503'
    },
    {
        property:'--bet-modal-button-font',
        value:'#050503'
    },   
    {
        property:'--bet-modal-button-font-selected',
        value:'#FFFFFF'
    },  
    {
        property:'--win-color',
        value:'#02D1FF'
    },
    {
        property:'--lose-color',
        value:'#F477FF'
    },
    {
        property:'--circle-counter-background-color',
        value:'#141C29'
    },
    {
        property:'--circle-counter-color',
        value:'#F1F1F1'
    },
    {
        property:'--desktop-header-background-color',
        value:'#F1F1F1'
    }                         
]
const style03 = [
    {
        property:'--background-color',
        value:'#FFFFFF'
    },
    {
        property:'--primary-color',
        value:'#FFD4D4'
    },
    {
        property:'--secondary-color',
        value:'#DAD4FF'
    },
    {
        property:'--primar-font-color',
        value:'#2400FF'
    },
    {
        property:'--pool-size-background',
        value:'#FFFFFF'
    },
    {
        property:'--secondary-font-color',
        value:'#2400FF'
    },
    {
        property:'--buttons-font-color',
        value:'#2400FF'
    },
    {
        property:'--pool-font-color',
        value:'#2400FF'
    },
    {
        property:'--card-header-font-color',
        value:'#2400FF'
    },
    {
        property:'--card-font-color',
        value:'#2400FF'
    },
    {
        property:'--card-buttons-font-color',
        value:'#2400FF'
    },
    {
        property:'--live-round-background',
        value:'#F1F1F1'
    },
    {
        property:'--live-price-font-color',
        value:'#050503'
    },
    {
        property:'--live-price-header-font-color',
        value:'#050503'
    },
    {
        property:'--live-price-locked-font-color',
        value:'#7c7b73'
    },
    {
        property:'--bet-button-modal-font-color',
        value:'#2400FF'
    },
    {
        property:'--bet-modal-background',
        value:'#FFFFFF'
    },
    {
        property:'--bet-button-border-color',
        value:'#2400FF'
    },
    {
        property:'--bet-button-background-color',
        value:'#FFFFFF'
    },
    {
        property:'--bet-modal-font-color',
        value:'#2400FF'
    },
    {
        property:'--bet-modal-button-background',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-background-selected',
        value:'#2400FF'
    },
    {
        property:'--bet-modal-button-font',
        value:'#2400FF'
    },   
    {
        property:'--bet-modal-button-font-selected',
        value:'#FFFFFF'
    },  
    {
        property:'--win-color',
        value:'#02D1FF'
    },
    {
        property:'--lose-color',
        value:'#F477FF'
    },
    {
        property:'--circle-counter-background-color',
        value:'#C8BFFF'
    },
    {
        property:'--circle-counter-color',
        value:'#2400FF'
    },
    {
        property:'--desktop-header-background-color',
        value:'#F1F1F1'
    }                         
]


const style04 = [
    {
        property:'--background-color',
        value:'#523C65'
    },
    {
        property:'--primary-color',
        value:'#FD9471'
    },
    {
        property:'--secondary-color',
        value:'#FEE4BD'
    },
    {
        property:'--primar-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--pool-size-background',
        value:'#523C65'
    },
    {
        property:'--secondary-font-color',
        value:'#D3D3D3'
    },
    {
        property:'--buttons-font-color',
        value:'#050503'
    },
    {
        property:'--pool-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--card-header-font-color',
        value:'#050503'
    },
    {
        property:'--card-font-color',
        value:'#050503'
    },
    {
        property:'--card-buttons-font-color',
        value:'#050503'
    },
    {
        property:'--live-round-background',
        value:'#21233F'
    },
    {
        property:'--live-price-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--live-price-header-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--live-price-locked-font-color',
        value:'#D3D3D3'
    },
    {
        property:'--bet-button-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-background',
        value:'#523C65'
    },
    {
        property:'--bet-button-border-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-button-background-color',
        value:'#523C65'
    },
    {
        property:'--bet-modal-font-color',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-background',
        value:'#342A5F'
    },
    {
        property:'--bet-modal-button-background-selected',
        value:'#F1F1F1'
    },
    {
        property:'--bet-modal-button-font',
        value:'#F1F1F1'
    },   
    {
        property:'--bet-modal-button-font-selected',
        value:'#342A5F'
    },  
    {
        property:'--win-color',
        value:'#00FF00'
    },
    {
        property:'--lose-color',
        value:'#FF00CA'
    },
    {
        property:'--circle-counter-background-color',
        value:'#7A6988'
    },
    {
        property:'--circle-counter-color',
        value:'#F1F1F1'
    },
    {
        property:'--desktop-header-background-color',
        value:'#342A5F'
    }                         
]

export const cssStyles : any = [style00 , style01 , style02 , style03 , style04]



export const getAboveIcon = (color : string)=>{
    
    return <svg width="35" height="48" viewBox="0 0 35 48" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M33.4531 35.1984L32.7042 35.9473L31.9554 35.1984L31.9554 12.732L32.7042 11.9831L33.4531 12.732L33.4531 35.1984Z" fill="url(#paint0_linear_13949_34004)"/>
    <path d="M3.49219 35.1984L2.74331 35.9473L1.99443 35.1984L1.99443 12.732L2.74331 11.9831L3.49219 12.732L3.49219 35.1984Z" fill="url(#paint1_linear_13949_34004)"/>
    <path d="M25.9687 41.1867L25.2199 41.9355L24.471 41.1867L24.471 6.73818L25.2199 5.9893L25.9687 6.73818L25.9687 41.1867Z" fill="url(#paint2_linear_13949_34004)"/>
    <path d="M10.9844 41.1867L10.2355 41.9355L9.48661 41.1867L9.48661 6.73818L10.2355 5.9893L10.9844 6.73818L10.9844 41.1867Z" fill="url(#paint3_linear_13949_34004)"/>
    <path d="M18.4687 47.1808L17.7199 47.9297L16.971 47.1808L16.971 0.750248L17.7199 0.00136954L18.4687 0.750248L18.4687 47.1808Z" fill="url(#paint4_linear_13949_34004)"/>
    <path d="M15.4688 2.13966L17.7154 -3.92815e-07L19.962 2.13966L19.962 20.3267L17.7154 22.4664L15.4688 20.3267L15.4688 2.13966Z" fill={color}/>
    <path d="M22.9688 8.13184L25.2154 5.99219L27.462 8.13184L27.462 17.3324L25.2154 19.472L22.9688 17.3324L22.9688 8.13184Z" fill={color}/>
    <path d="M30.4531 14.1201L32.6998 11.9805L34.9464 14.1201L34.9464 14.3341L32.6998 16.4737L30.4531 14.3341L30.4531 14.1201Z" fill={color}/>
    <path d="M7.98438 8.13184L10.231 5.99219L12.4777 8.13184L12.4777 23.3234L10.231 25.4631L7.98438 23.3234L7.98438 8.13184Z" fill={color}/>
    <path d="M0.5 14.1201L2.74664 11.9805L4.99328 14.1201L4.99328 26.3162L2.74664 28.4558L0.500003 26.3162L0.5 14.1201Z" fill={color}/>
    <defs>
    <linearGradient id="paint0_linear_13949_34004" x1="32.7042" y1="35.9473" x2="32.7042" y2="11.9831" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441" stopOpacity="0"/>
    <stop offset="1" stopColor="#0F2441"/>
    </linearGradient>
    <linearGradient id="paint1_linear_13949_34004" x1="2.74331" y1="35.9473" x2="2.74331" y2="11.9831" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441" stopOpacity="0"/>
    <stop offset="1" stopColor="#0F2441"/>
    </linearGradient>
    <linearGradient id="paint2_linear_13949_34004" x1="25.2199" y1="41.9355" x2="25.2199" y2="5.9893" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441" stopOpacity="0"/>
    <stop offset="1" stopColor="#0F2441"/>
    </linearGradient>
    <linearGradient id="paint3_linear_13949_34004" x1="10.2355" y1="41.9355" x2="10.2355" y2="5.9893" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441" stopOpacity="0"/>
    <stop offset="1" stopColor="#0F2441"/>
    </linearGradient>
    <linearGradient id="paint4_linear_13949_34004" x1="17.7199" y1="47.9297" x2="17.7199" y2="0.00136954" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441" stopOpacity="0"/>
    <stop offset="1" stopColor="#0F2441"/>
    </linearGradient>
    </defs>
    </svg>
    
    
}

export const getBellowIcon = (color : string)=>{
    
    return <svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M33.9141 35.1984L33.1652 35.9473L32.4163 35.1984L32.4163 12.732L33.1652 11.9831L33.9141 12.732L33.9141 35.1984Z" fill="url(#paint0_linear_13949_33989)"/>
    <path d="M3.96094 35.1984L3.21206 35.9473L2.46318 35.1984L2.46318 12.732L3.21206 11.9831L3.96094 12.732L3.96094 35.1984Z" fill="url(#paint1_linear_13949_33989)"/>
    <path d="M26.4297 41.1906L25.6808 41.9395L24.9319 41.1906L24.9319 6.74209L25.6808 5.99321L26.4297 6.74209L26.4297 41.1906Z" fill="url(#paint2_linear_13949_33989)"/>
    <path d="M11.4531 41.1925L10.7042 41.9414L9.95536 41.1925L9.95536 6.74404L10.7042 5.99516L11.4531 6.74404L11.4531 41.1925Z" fill="url(#paint3_linear_13949_33989)"/>
    <path d="M18.9453 47.1789L18.1964 47.9277L17.4476 47.1789L17.4475 0.748295L18.1964 -0.000583583L18.9453 0.748295L18.9453 47.1789Z" fill="url(#paint4_linear_13949_33989)"/>
    <path d="M20.4375 45.7881L18.1909 47.9277L15.9442 45.7881L15.9442 27.601L18.1909 25.4613L20.4375 27.601L20.4375 45.7881Z" fill={color}/>
    <path d="M12.9453 39.7998L10.6987 41.9395L8.45203 39.7998L8.45203 30.5993L10.6987 28.4596L12.9453 30.5993L12.9453 39.7998Z" fill={color}/>
    <path d="M5.46094 33.8076L3.2143 35.9473L0.967657 33.8076L0.967657 33.5936L3.2143 31.454L5.46094 33.5936L5.46094 33.8076Z" fill={color}/>
    <path d="M27.9297 39.8017L25.683 41.9414L23.4364 39.8017L23.4364 24.6102L25.683 22.4705L27.9297 24.6102L27.9297 39.8017Z" fill={color}/>
    <path d="M35.4141 33.8076L33.1674 35.9473L30.9208 33.8076L30.9208 21.6116L33.1674 19.4719L35.4141 21.6116L35.4141 33.8076Z" fill={color}/>
    <defs>
    <linearGradient id="paint0_linear_13949_33989" x1="33.1652" y1="35.9473" x2="33.1652" y2="11.9831" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441"/>
    <stop offset="1" stopColor="#0F2441" stopOpacity="0"/>
    </linearGradient>
    <linearGradient id="paint1_linear_13949_33989" x1="3.21206" y1="35.9473" x2="3.21206" y2="11.9831" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441"/>
    <stop offset="1" stopColor="#0F2441" stopOpacity="0"/>
    </linearGradient>
    <linearGradient id="paint2_linear_13949_33989" x1="25.6808" y1="41.9395" x2="25.6808" y2="5.99321" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441"/>
    <stop offset="1" stopColor="#0F2441" stopOpacity="0"/>
    </linearGradient>
    <linearGradient id="paint3_linear_13949_33989" x1="10.7042" y1="41.9414" x2="10.7042" y2="5.99516" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441"/>
    <stop offset="1" stopColor="#0F2441" stopOpacity="0"/>
    </linearGradient>
    <linearGradient id="paint4_linear_13949_33989" x1="18.1964" y1="47.9277" x2="18.1964" y2="-0.000583583" gradientUnits="userSpaceOnUse">
    <stop stopColor="#0F2441"/>
    <stop offset="1" stopColor="#0F2441" stopOpacity="0"/>
    </linearGradient>
    </defs>
    </svg>
    
    
    
}